<template>
  <div>
    <!-- 表示開始日時 -->
    <v-row class="mx-6">
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <DateTimePicker
          v-model="startAt"
          title="表示開始日時"
          :required=true
        ></DateTimePicker>
      </v-col>
    </v-row>

    <!-- 表示終了日時 -->
    <v-row class="mx-6">
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <DateTimePicker
          v-model="endAt"
          title="表示終了日時"
        ></DateTimePicker>
      </v-col>
    </v-row>

    <!-- 件名 -->
    <v-row class="mx-6">
      <v-col cols="4">
        <v-text-field
          class="title__filed"
          v-model="title"
          label="件名"
          clearable
          :counter="30"
        >
          <template #[`label`]>
            件名 <font color="red">❇︎</font>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <!-- 表示場所 -->
    <v-row class="mx-6">
      <v-col cols="4">
        <p class="mb-0">表示場所<font color="red">❇︎</font></p>
        <v-checkbox
          class="show-area__checkbox mt-1 mr-4"
          v-model="showAreas"
          label="ログインページ"
          value="1"
          color="secondary"
          hide-details
        ></v-checkbox>
        <v-checkbox
          class="show-area__checkbox mt-1"
          v-model="showAreas"
          label="TOP"
          value="2"
          color="secondary"
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row>

    <!-- 添付ファイル -->
    <v-row class="mx-6">
      <v-col cols="4">
        <v-file-input
          label="添付ファイル"
          truncate-length="15"
          show-size
          v-model="attachment"
        ></v-file-input>
      </v-col>
    </v-row>

    <!-- 本文 -->
    <v-row class="mx-6">
      <v-col cols="8">
        本文 <font color="red">❇︎</font>
        <vue-editor :editor-toolbar="bodyToolbar" v-model="message" />
        <div class="v-text-field__details">
          <div class="v-messages theme--light"><div class="v-messages__wrapper"></div></div>
          <div class="v-counter theme--light" v-bind:style="{color: errorColor}">
            {{ countMessageLength }} / 500
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- ボタンら -->
    <v-btn
      class="mt-6 ml-6"
      small
      color="secondary"
      dark
      @click.stop="submit"
    >
      保存
    </v-btn>
    <v-btn
      class="mt-6 ml-6"
      small color="gray"
      @click.stop="$router.push('/admin/notifications')"
      >
        お知らせ一覧に戻る
      </v-btn>
  </div>
</template>

<script>
import moment from 'moment'
import { VueEditor } from "vue2-editor";
import DateTimePicker from '@/components/molecules/DateTimePicker'

export default {
  components: {
    VueEditor,
    DateTimePicker
  },
  data () {
    return {
      bodyToolbar: [
        ['bold', 'underline', { 'color': [] }, 'link', { 'size': ['small', false, 'large', 'huge'] }, 'clean']
      ],
    }
  },

  async mounted() {
    await this.$store.dispatch('notification/getAttached', {
      filePath: this.$store.state.notification.filePath,
      filename: this.$store.state.notification.filename,
    })
  },

  computed: {
    startAt: {
      get () {
        return this.$store.state.notification.startAt
          ? moment(new Date(this.$store.state.notification.startAt)).format('YYYY-MM-DD HH:mm')
          : ''
      },
      set (value) {
        this.$store.commit('notification/setStartAt', {
          startAt: value ? moment(new Date(value)).format('YYYY/MM/DD HH:mm') : ''
        })
      }
    },
    endAt: {
      get () {
        return this.$store.state.notification.endAt
          ? moment(new Date(this.$store.state.notification.endAt)).format('YYYY-MM-DD HH:mm')
          : ''
      },
      set (value) {
        this.$store.commit('notification/setEndAt', {
          endAt: value ? moment(new Date(value)).format('YYYY/MM/DD HH:mm') : ''
        })
      }
    },
    title: {
      get () {
        return this.$store.state.notification.title
      },
      set (value) {
        this.$store.commit('notification/setTitle', {
          title: value
        })
      }
    },
    showAreas: {
      get () {
        return this.$store.state.notification.showAreas
      },
      set (value) {
        this.$store.commit('notification/setShowAreas', {
          showAreas: value
        })
      }
    },
    message: {
      get () {
        return this.$store.state.notification.message
      },
      set (value) {
        this.$store.commit('notification/setMessage', {
          message: value
        })
      }
    },
    attachment: {
      get () {
        return this.$store.state.notification.attachment
      },
      set (value) {
        this.$store.commit('notification/setAttachment', {
          attachment: value
        })
      }
    },
    countMessageLength() {
      //タグを削除してから文字数をカウント
      return this.message.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'').length
    },
    errorColor() {
      //300文字超えたら赤文字にする
      return this.countMessageLength > 500 ? '#b71c1c' : '';
    }
  },
  methods: {
    async submit() {
      const res = await this.$store.dispatch('notification/validate')
      if (res.status === 'error') this.$toasted.global.error({ message: res.message })
      else this.$emit('submit')
    },
  },
}
</script>

<style lang="stylus" scoped>
  .show-area__checkbox
    display inline-block

</style>
